export default function Education({ education }) {
  return (
    <div>
      <p className="text-sm font-semibold text-stone-900 mb-0.5">{education.degree}</p>
      <p className="text-sm text-stone-500">{education.institution}</p>
      <div className="flex items-center gap-2 mt-2">
        <span className="text-xs font-mono bg-stone-100 text-stone-500 px-2 py-0.5 rounded-sm">
          {education.year}
        </span>
        <span className="text-xs font-mono bg-stone-100 text-stone-500 px-2 py-0.5 rounded-sm">
          {education.gpa}
        </span>
      </div>
    </div>
  );
}
